// extracted by mini-css-extract-plugin
export default {"base":"views-ProductPage-themes-BGH-sections-productSection__base--_VQkc","title":"views-ProductPage-themes-BGH-sections-productSection__title--lKH4u"};